import { StylesConfig } from "react-select";

export type SelectOption = {
  value: string;
  label: string;
};

export const customSelectStyles: StylesConfig<SelectOption, false> = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "30px",
    borderColor: state.isFocused ? "#86b7fe" : "var(--input-border)",
    boxShadow: state.isFocused
      ? "0 0 0 .25rem rgba(13, 110, 253, .25)"
      : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#86b7fe" : "var(--input-border)",
    },
  }),

  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    borderRadius: "15px",
    overflow: "hidden",
  }),

  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "var(--placeholder-color)",
  }),

  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f5f5f5" : "#fff",
    color: "var(--text-main)",
    padding: "10px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#f5f5f5",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),
};

export const customFiltersStyles = (
  customleft: string,
): StylesConfig<SelectOption, false> => ({
  control: (provided, state) => ({
    ...provided,
    borderRadius: "30px",
    borderColor: state.isFocused ? "#86b7fe" : "var(--input-border)",
    boxShadow: state.isFocused
      ? "0 0 0 .25rem rgba(13, 110, 253, .25)"
      : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#86b7fe" : "var(--input-border)",
    },
  }),

  menu: (provided, state) => {
    const menuWidth = (state.selectProps as any)?.["data-menu-width"] || "100%";

    return {
      ...provided,
      zIndex: 9999,
      borderRadius: "15px",
      overflow: "hidden",

      backgroundColor: "rgba(255, 255, 255, 0.15)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",

      border: "1px solid rgba(255, 255, 255, 0.2)",

      width: menuWidth,
      left: customleft,
      transform: "translateX(-50%)",
    };
  },
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "var(--placeholder-color)",
  }),

  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "color-mix(in srgb, var(--placeholder-color) 50%, transparent)"
      : "",
    color: "var(--text-main)",
    padding: "10px",
    cursor: "pointer",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    "&:active": {
      backgroundColor:
        "color-mix(in srgb, var(--placeholder-color) 50%, transparent)",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),
});
